module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Wallet-1235ada5cfaa937c072aeb7718741193.svg";